export default "__VITE_ASSET__BYlN4hIb__"